import React from 'react';
import { formatCurrency } from '../../utils/money';

// Puramente apresentacional — nenhum import de service, nenhum hook de leitura do Apollo,
// nenhum fetch (ai/architecture.core.md §5; ai/anti-patterns.md §1 "Data Fetching Inside
// Reusable Components" é débito a não replicar).

export interface KpiCardProps {
  titulo: string;
  valor: number;
  legenda?: string;
  loading?: boolean;
}

function slugify(titulo: string): string {
  return titulo
    .toLowerCase()
    .normalize('NFD')
    .replace(/[̀-ͯ]/g, '')
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/(^-|-$)/g, '');
}

const KpiCard: React.FC<KpiCardProps> = ({ titulo, valor, legenda, loading }) => {
  const slug = slugify(titulo);
  return (
    <div className="card border-0 shadow-xss rounded-xxl p-3 h-100" data-testid={`kpi-${slug}`}>
      <span className="text-grey-500 font-xsss fw-600 d-block mb-1">{titulo}</span>
      <h4 className="fw-700 mb-0">{loading ? '—' : formatCurrency(valor)}</h4>
      {legenda && <span className="text-grey-500 font-xssss d-block mt-1">{legenda}</span>}
    </div>
  );
};

export default KpiCard;
